import { render, staticRenderFns } from "./PosicaoNotaFiscal.vue?vue&type=template&id=1fbf6f62"
import script from "./PosicaoNotaFiscal.vue?vue&type=script&lang=js"
export * from "./PosicaoNotaFiscal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports